"use client";
import { ContentPipeline } from "@/components/ContentPipeline";

export default function Home() {
  return <ContentPipeline />;
}
